import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import bankAccConstants from "../constants/bankAccConstants";

const addBankAcc = (payload: any) => {
  return api.post(Endpoint.createBankAccDetails, payload);
};

const editBankAccDetails = (payload: any) =>
  api.put(`${Endpoint.editBankAccDetails}/${payload.id}/`, payload.body);

const getBankAccDetails = (payload: any) =>
  api.get(Endpoint.retrieveBankAccDetails, {
    params: {
      ...(payload.clientId && { client_id: payload.clientId }),
    },
  });

function* createBankAccDetails(action: any) {
  try {
    const response: AxiosResponse = yield call(addBankAcc, action.payload);
    yield put({
      type: bankAccConstants.ADD_BANK_ACC_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: bankAccConstants.ADD_BANK_ACC_FAILURE, err: e });
  }
}

function* editBankAccDetailsAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      editBankAccDetails,
      action.payload,
    );
    yield put({
      type: bankAccConstants.EDIT_BANK_ACC_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: bankAccConstants.EDIT_BANK_ACC_FAILURE, err: e });
  }
}

function* getBankAccDetailsAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getBankAccDetails,
      action.payload,
    );

    yield put({
      type: bankAccConstants.GET_BANK_ACC_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: bankAccConstants.GET_BANK_ACC_FAILURE, err: e });
  }
}

function* bankAccSaga() {
  yield all([
    takeEvery(bankAccConstants.ADD_BANK_ACC_REQ, createBankAccDetails),
  ]);
  yield all([
    takeEvery(bankAccConstants.EDIT_BANK_ACC_REQUEST, editBankAccDetailsAsync),
  ]);
  yield all([
    takeEvery(bankAccConstants.GET_BANK_ACC_REQUEST, getBankAccDetailsAsync),
  ]);
}

export default bankAccSaga;
